export default __webpack_public_path__ + "static/media/padel-firstServe-cover.d1868d73.png";